export { default as SalesBrandPermissionSlot } from './SalesBrandPermissionSlot';
